export const address = {
    streetAddress: '200 Pennbrook Pkwy',
    city: 'Lansdale',
    state: 'PA',
    zip: '19446'
}

export const telephone = '(215) 661-1884';

export const mail = 'yangsmartialart@gmail.com';